import React from "react";
import AmountInvestedResult from '../AmountInvestedResult';

const SharePurchasedTabContent = () => {
  return <div className="amount-invested-tab-content">
    <AmountInvestedResult />
  </div>;
};

export default SharePurchasedTabContent;
